// Challenging Assumptions Template - Common App Prompt #3
export const challengingAssumptionsTemplate = {
  id: 'challengingAssumptions',
  title: 'Challenging Assumptions',
  description: 'For times when you questioned or challenged a belief or idea, showing intellectual courage and independent thinking',
  sections: [
    {
      id: 'the_questioning_moment',
      label: 'The Questioning Moment',
      type: 'opening',
      prompt: 'What specific moment or experience first made you doubt something everyone else seemed to accept?',
      coachVoice: "I want the exact trigger - not a gradual realization, but the precise moment when you thought 'wait, this doesn't add up.'",
      sample: "Our history teacher was explaining why the atomic bomb saved lives by ending WWII quickly, when my Japanese exchange partner Yuki quietly asked to step outside. I found her crying in the hallway, and suddenly realized I'd never heard this 'saving lives' narrative from any perspective but the American one.",
      minWords: 80,
      unlockWords: 40
    },
    {
      id: 'what_made_you_dig_deeper',
      label: 'What Made You Dig Deeper',
      type: 'stakes',
      prompt: 'Why did this particular question matter enough to you that you couldn\'t just let it go?',
      coachVoice: "Lots of things seem questionable, but most people shrug and move on. What was it about this specific issue that grabbed you and wouldn't let go?",
      sample: "I realized I'd been accepting historical narratives without considering who was telling them. If I could be so wrong about something this significant, what else was I blindly accepting? It wasn't just about WWII anymore - it was about whether I was thinking for myself or just echoing what I'd been taught.",
      minWords: 80,
      unlockWords: 40
    },
    {
      id: 'your_investigation_approach',
      label: 'Your Investigation Approach',
      type: 'approach',
      prompt: 'Show me how you systematically challenged this belief. What sources, methods, or perspectives did you seek out?',
      coachVoice: "This is where I want to see your intellectual process. How did YOU go about testing what you'd been told?",
      sample: "I started reading Japanese accounts of Hiroshima, not just American textbooks. I interviewed my grandfather's Navy friend about his Pacific experience, sought out documentaries from multiple countries, and even joined an online forum where historians debated this exact question. I created a timeline comparing what different sources emphasized and omitted.",
      minWords: 100,
      unlockWords: 50
    },
    {
      id: 'how_questioning_changed_you',
      label: 'How Questioning Changed You',
      type: 'growth',
      prompt: 'How has developing this questioning mindset affected the way you approach other beliefs or ideas?',
      coachVoice: "I want to see evidence that this experience created a lasting change in how you think. Give me a recent example of this new approach in action.",
      sample: "Last month, when everyone was sharing articles about a new environmental study, I found myself automatically asking 'who funded this research?' and looking for contradictory data before forming an opinion. My friends joke that I've become a 'professional skeptic,' but I've realized that questioning assumptions isn't cynicism - it's intellectual honesty.",
      minWords: 80
    }
  ]
};